import {Contact, InvoiceInfo} from "models"
import React, {useRef} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import {FlashNotifications as FlashMessage} from "flash-notifications"
import {Form} from "@kaspernj/api-maker/build/form"
import Heading from "components/utils/heading"
import InputValidator from "shared/input-validator"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import useI18n from "i18n-on-steroids/src/use-i18n.mjs"
import UtilsButton from "components/utils/button"
import UtilsInput from "components/utils/input"
import {View} from "react-native"

export default memo(shapeComponent(class ComponentsPlansSignUpModalStepEanInvoiceInfo extends ShapeComponent {
  static propTypes = {
    onEanInvoiceInfoSubmit: PropTypes.func.isRequired
  }

  setup() {
    const {t} = useI18n({namespace: "js.components.plans.sign_up_modal.step_ean_invoice_info"})
    const formRef = useRef()

    this.setInstance({formRef, t})
  }

  render() {
    const {t} = this.tt

    return (
      <View dataSet={{component: "plans--sign-up-modal--step-ean-invoice-info"}}>
        <Form formObjectRef={this.tt.formRef}>
          <View style={{display: "flex", alignItems: "center"}}>
            <Heading>
              {t(".invoice_information")}
            </Heading>
          </View>
          <UtilsInput
            dataSet={{class: "school-name-input"}}
            label={t(".school_name")}
            name="invoice_info[name]"
            style={{marginBottom: 15}}
          />
          <UtilsInput
            dataSet={{class: "ean-number-input"}}
            label={t(".ean_number")}
            name="invoice_info[eanNumber]"
            style={{marginBottom: 15}}
          />
          <UtilsInput
            dataSet={{class: "note-input"}}
            label={t(".note_or_other")}
            name="invoice_info[note]"
            style={{marginBottom: 15}}
          />
          <UtilsButton dataSet={{class: "submit-ean-invoice-info-button"}} onPress={this.tt.onContinuePressed} title={t(".continue")} />
        </Form>
      </View>
    )
  }

  onContinuePressed = () => {
    const formData = this.tt.formRef.current.asObject()
    const invoiceInfo = formData.invoice_info || {}

    const inputValidator = new InputValidator({
      inputs: invoiceInfo,
      translations: {
        eanNumber: InvoiceInfo.humanAttributeName("eanNumber"),
        name: Contact.humanAttributeName("name")
      }
    })

    inputValidator
      .validate("eanNumber", {presence: true})
      .validate("name", {presence: true})

    if (inputValidator.isInvalid()) {
      FlashMessage.alert(inputValidator.getErrorMessages().join(" "))
    } else {
      this.p.onEanInvoiceInfoSubmit({invoiceInfo})
    }
  }
}))
